/**
 * The M2 bridge's raiders (M3 plan R22h, order `FEATURE_ORDER.reach`; the career in the Reach only): once the career
 * feature (order 150) has provided `m2`, binds M2's encounter director to the Reach session, so its raider groups and
 * the repo crew spawn through `session.spawnGroup` in whatever system the player is in (`src/bridge/m2/raiders.ts`,
 * loaded lazily with the Reach). No per-tick or per-frame work.
 */
import { FEATURE_ORDER, type GameContext, type GameFeature } from '../../app/feature'

let unbind: (() => void) | null = null

const feature: GameFeature = {
  name: 'bridgeRaiders',
  order: FEATURE_ORDER.reach,
  async init(ctx: GameContext): Promise<void> {
    const reach = ctx.reach
    const m2 = ctx.services.maybe('m2')
    if (reach === null || m2 === undefined) return
    const { attachReachRaiders } = await import('../../bridge/m2/raiders')
    unbind = attachReachRaiders({ sim: ctx.sim, data: ctx.data, reach, encounters: m2.space.encounters })
  },
  dispose(): void {
    unbind?.()
    unbind = null
  },
}

export default feature
